import emoji from './emoji';

export const commonUtil = {
  emoji,
};
